<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.search_name"
          placeholder="请输入分类昵称"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" icon="ios-add" @click="diyDom.showModal = true">添加文章分类</Button>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="apiData.per_page"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
    <!-- 添加分类 -->
    <addCategory v-model="diyDom.showModal" :id="diyData.id" :isEdit="diyDom.isEdit" @on-success="getTableList"></addCategory>
  </div>
</template>

<script>
import * as apiArticle from '@/api/article'
import addCategory from './add-category.vue'
export default {
  name: 'category-list',
  components: {
    addCategory
  },
  data () {
    return {
      query: {},
      search: {
        search_name: '',
        page: 1
      },
      diyDom: {
        showModal: false,
        isEdit: false
      },
      diyData: {
        id: '',
        columns: [
          {
            title: 'ID',
            render: (h, params) => {
              return h('div', params.index + 1)
            }
          },
          {
            title: '分类名称',
            key: 'title'
          },
          {
            title: '排序',
            key: 'sort'
          },
          {
            title: '状态',
            key: 'status_lab'
          },
          {
            title: '操作',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.diyDom.isEdit = true
                        this.diyData.id = params.row.id
                        this.diyDom.showModal = true
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: 'red'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title:'提示',
                          content:"请确认是否删除当前数据？",
                          onOk:() => {
                            apiArticle.apiArticleCategoryDetele(params.row.id).then(res => {
                              this.$Message.success('已删除')
                              this.getTableList()
                            })
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        per_page: 0,
        tableList: []
      }
    }
  },
  methods: {
    // 获取表格数据
    getTableList () {
      this.$store.commit('setSpinShow',true)
      apiArticle.apiArticleCategoryList({...this.search}).then(res => {
        const {data,meta} = res
        this.apiData.tableList = data
        this.apiData.per_page = meta.pagination.per_page
        this.apiData.total = meta.pagination.total
      }).finally(() => this.$store.commit('setSpinShow',false))
    },
    // 分页
    pageChange (e) {
      this.search.page = e
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.page = 1
      this.getTableList()
    },
    // 清空
    clearFn () {
      this.search = {
        search_name: '',
        page: 1
      }
      this.getTableList()
    }
  },
  watch: {
    'diyDom.showModal' (val) {
      if (!val) {
        this.diyDom.isEdit = false
      }
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }
    .table {
      margin-top: 10px;
    }
    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
